import {fetchJSON} from "../../utils/dataAccess";

export function loadQuestionBankCategoriesForSelect(valueProperty = 'id') {
  return dispatch => {
    dispatch(loading(true));
    fetchJSON('/question_bank_categories?pagination=false').then((categories) => {
      dispatch(categoriesLoaded(categories['hydra:member'].map(
        function (category) {
          return {
            value: category[valueProperty],
            text: category.name,
          }
        }
      )));
      dispatch(loading(false));
    }).catch(e => {
      dispatch(loading(false));
      dispatch(error(e.message));
    })
  };
}

export function loading(loading) {
  return {type: 'QUESTIONBANKCATEGORY_FOR_SELECT_LOADING', loading};
}

export function error(error) {
  return {type: 'QUESTIONBANKCATEGORY_FOR_SELECT_ERROR', error};
}

export function categoriesLoaded(retrieved) {
  return {type: 'QUESTIONBANKCATEGORY_FOR_SELECT_RETRIEVED', retrieved};
}
